import { Link, useNavigate } from "react-router-dom";
import { Compass, ArrowLeft, LayoutDashboard } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-s360-app flex items-center justify-center px-6">
      <div className="flex flex-col items-center text-center gap-4 max-w-md">
        {/* Brand */}
        <div className="flex items-baseline gap-0.5 font-bold text-lg tracking-[-0.02em] text-s360-ink mb-2">
          <span>semi</span>
          <span className="text-s360-teal">360</span>
          <span className="text-s360-teal text-[10px] font-bold ml-0.5">AI</span>
        </div>

        <span className="w-16 h-16 rounded-2xl bg-s360-violet-50 text-s360-violet inline-flex items-center justify-center">
          <Compass className="w-8 h-8" />
        </span>

        <span className="font-mono text-[72px] leading-none font-bold tracking-[-0.02em] text-s360-ink tabular-nums">
          404
        </span>
        <h2 className="text-2xl font-semibold text-s360-fg1">Page not found</h2>
        <p className="text-sm text-s360-fg3">
          The page you're looking for doesn't exist. It might have been moved, renamed, or deleted.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-3">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-s360-violet text-white text-sm font-semibold hover:bg-s360-violet-600 transition-colors"
          >
            <LayoutDashboard className="w-4 h-4" /> Go to dashboard
          </Link>
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-white border border-s360-stroke1 text-sm font-semibold text-s360-fg1 hover:bg-s360-bg2 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Go back
          </button>
        </div>
      </div>
    </div>
  );
}
